import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SetItemDepthCommand from '../command/setItemDepthCommand';
import DropdownField from './dropdownField';

/**
 * @class DepthDropdownField
 */
export default class DepthDropdownField extends DropdownField {
    type = 'depthDropdown';
    supports = 'supportsDepth';

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateText(item) {
        this.button.children('.text').text(item.get('depth'));
    }

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', (e) => {
            const target = $(e.target);
            const depth = target.data('item');

            this.tryUpdateItem(this.currentItem, this.currentItem.get('depth') - depth);
        });
    }

    /**
     * Update options with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const options = [];
        const current = item.get('depth');

        item.supportedDepths.forEach((value) => {
            options.push({
                key: value,
                value: `${value}mm`,
                active: value === current,
            });
        });

        this.setOptions(options);
    }

    /**
     * Check if item supports depth dropdowns.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength && item
            && supportFlag && item[supportFlag]
            && item.supportedDepths && Array.isArray(item.supportedDepths);
    }

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        const depth = this.getValue() + difference;

        this.assertItemValue(item, 'depth', depth);

        const command = new SetItemDepthCommand(item, depth);

        history.addAndExecuteCommand(command);
    }
}
